import { Instance, types } from 'mobx-state-tree'

import { FilterType } from './FilterType'

export const SearchFieldFilterModel = types
  .model('SearchFieldFilterModel')
  .props({
    fieldNetworkName: types.maybe(types.string),
    type: types.literal(FilterType.SEARCH),
    value: types.maybeNull(types.string),
    placeholder: types.string,
  })
  .views((self) => ({
    get getFilterAsUrlParam(): string {
      if (self.fieldNetworkName === undefined) {
        throw Error('Filter must have fieldNetworkName if present in URL params')
      }
      return self.value === null ? `` : `${self.fieldNetworkName}=${self.value}`
    },
  }))
  .actions((self) => ({
    setValue(value: typeof self.value) {
      if (value===''){
        self.value = null // in case of empty string (for example after deleting the text), we will "reset" the filter.
      } else {
        self.value = value
      }
    },
  }))

export type SearchFieldFilter = Instance<typeof SearchFieldFilterModel>
